export class QuoteApplication {
    formStatus = 'notstarted';
    insuredIncurredYes = 'yes';
    insuredIncurredNo = 'no';
    insuredIncurredNoPriorCoverage = 'no prior coverage';

    policyOrCoverageDeclinedYes = 'yes';
    policyOrCoverageDeclinedNo = 'no';

    insuredSuedYes = 'yes';
    insuredSuedNo = 'no';

    insuredAwareOfClaimYes = 'yes';
    insuredAwareOfClaimNo = 'no';

    insuredIndustryExperienceLess1year = 'Less than 1 Year';
    insuredIndustryExperienceMore1year = 'More than 1 Year';

    insuredOwnedEquipmentValueLess500K = 'Less than $500K';
    insuredOwnedEquipmentValue500Kto1M = '$500K - $1M';
    insuredOwnedEquipmentValueMore1M = 'More than $1M';

    activityExistInProductionYes = 'yes';
    activityExistInProductionNo = 'no';

    excessTotalBudgetCheck: boolean = false;
    threeDFilmingRisksCheck: boolean = false;
    realityTvShowsCheck: boolean = false;
    vloggersCheck: boolean = false;
    featureFilmsCheck: boolean = false;
    shortFilmsCheck: boolean = false;
    scriptedTvOrPilotsCheck: boolean = false;
    adultFilmsCheck: boolean = false;
    foreignFilmCheck: boolean = false;
    hiddenCameraFilmingCheck: boolean = false;
    useOfStuntsCheck: boolean = false;
    coastalFilmingCheck: boolean = false;
    longerFilmingPeriod: boolean = false;


    'INCURRED-LOSSES-OPT1' : boolean = true;
    'INCURRED-LOSSES-OPT2' : boolean = true;
    'INCURRED-LOSSES-OPT3' : boolean = true;
    'INSURED-DECLINED-OPT1' : boolean = true;
    'INSURED-DECLINED-OPT2' : boolean = true;
    'INSURED-SUED-OPT1' : boolean = true;
    'INSURED-SUED-OPT2' : boolean = true;
    'INSURED-CLAIM-AWARE-OPT1' : boolean = true;
    'INSURED-CLAIM-AWARE-OPT2' : boolean = true;
    'INDUSTRY-EXPERIENCE-OPT1' : boolean = true;
    'INDUSTRY-EXPERIENCE-OPT2' : boolean = true;
    'OWNED-EQUIPMENT-OPT1' : boolean = true;
    'OWNED-EQUIPMENT-OPT2' : boolean = true;
    'OWNED-EQUIPMENT-OPT3' : boolean = true;
    'ACTIVITIES-OPT1' : boolean = true;
    'ACTIVITIES-OPT2' : boolean = true;
}
